/**
 * EditorTextarea — labeled textarea field
 */

interface EditorTextareaProps {
  label: string;
  value: string | null | undefined;
  onChange: (value: string) => void;
  placeholder?: string;
  rows?: number;
}

export function EditorTextarea({ label, value, onChange, placeholder, rows = 3 }: EditorTextareaProps) {
  return (
    <div className="field">
      <label className="field-label">{label}</label>
      <textarea
        className="field-input"
        value={value || ''}
        onChange={(e) => onChange(e.target.value)}
        placeholder={placeholder}
        rows={rows}
      />
    </div>
  );
}
